import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const WebsitesOnePagePage = lazy(() => import('../pages/services/websites-one-page/page'));
const WebsitesInformativosPage = lazy(() => import('../pages/services/websites-informativos/page'));
const EcommercePage = lazy(() => import('../pages/services/ecommerce/page'));
const IdentidadeVisualPage = lazy(() => import('../pages/services/identidade-visual/page'));
const MateriaisPromocionaisPage = lazy(() => import('../pages/services/materiais-promocionais/page'));
const DesignParaImpressaoPage = lazy(() => import('../pages/services/design-para-impressao/page'));
const FotografiaPage = lazy(() => import('../pages/services/fotografia/page'));
const VideografiaPage = lazy(() => import('../pages/services/videografia/page'));
const StreamingAoVivoPage = lazy(() => import('../pages/services/streaming-ao-vivo/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/servicos/websites-one-page',
    element: <WebsitesOnePagePage />,
  },
  {
    path: '/servicos/websites-informativos',
    element: <WebsitesInformativosPage />,
  },
  {
    path: '/servicos/ecommerce',
    element: <EcommercePage />,
  },
  {
    path: '/servicos/identidade-visual',
    element: <IdentidadeVisualPage />,
  },
  {
    path: '/servicos/materiais-promocionais',
    element: <MateriaisPromocionaisPage />,
  },
  {
    path: '/servicos/design-para-impressao',
    element: <DesignParaImpressaoPage />,
  },
  {
    path: '/servicos/fotografia',
    element: <FotografiaPage />,
  },
  {
    path: '/servicos/videografia',
    element: <VideografiaPage />,
  },
  {
    path: '/servicos/streaming-ao-vivo',
    element: <StreamingAoVivoPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;